import * as React from "react"

const LoadAndTrip = (props) => (
  <svg width={24} height={22} xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{"Load and trip"}</title>
    <path
      d="M8.75 12.5a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 .75-.75h7.5Zm12 0a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 .75-.75h7.5ZM8 14H2v6h6v-6Zm12 0h-6v6h6v-6ZM8.75.5a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-7.5A.75.75 0 0 1 1.25.5h7.5Zm12 0a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 .75-.75h7.5ZM8 2H2v6h6V2Zm12 0h-6v6h6V2Z"
      fill="#B3D4F5"
      fillRule="evenodd"
    />
  </svg>
)

export default LoadAndTrip;